import { CART_ADD_ITEM, CART_LOAD_ITEMS, CART_REMOVE_ITEM, CART_TOOGLE_SELECCT_ITEM } from "../consts"

export const addToCart = (item) => {
    return {
        type: CART_ADD_ITEM,
        item
    }
}

export const loadCart = (items) => {
    return {
        type: CART_LOAD_ITEMS,
        items
    }
}

export const toogleSelectItemCart = (index) => {
    return {
        type: CART_TOOGLE_SELECCT_ITEM,
        index
    }
}

export const removeCartItemAction = (item) => {
    return {
        type: CART_REMOVE_ITEM,
        item
    }
}